<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps } from 'vue';

/*==================================================================*/
/*================== IMPORTS DE COMPONENTES ========================*/
/*==================================================================*/

import CartaoBase from '@/components/v2/base/CartaoBase/CartaoBase.vue';
import CampoCheckboxBase from '@/components/v2/base/CampoCheckboxBase/CampoCheckboxBase.vue';
import CampoTextoBase from '@/components/v2/base/CampoTextoBase/CampoTextoBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({

    dado: {
        type: Object,
        default: () => ({})
    }

});

</script>

<template>

    <CartaoBase>

        <template #header>

            <div class="c-header">

                <span class="c-header__titulo">
                    
                    <CampoCheckboxBase
                        :value="props?.dado?.recorrencia"
                        disabled
                    >
                      
                        Recorrências

                    </CampoCheckboxBase>

                </span>

            </div>

        </template>

        <template #body>

            <div class="c-grid">

                <CampoTextoBase
                    label="Quantidade Total de Recorrências"
                    :value="props?.dado?.recorrenciaQuantidadeTotal"
                    disabled
                ></CampoTextoBase>

                <CampoTextoBase
                    label="Quantidade Atual de Recorrências Geradas"
                    :value="props?.dado?.recorrenciaQuantidadeAtual"
                    disabled
                ></CampoTextoBase>

            </div>

        </template>

    </CartaoBase>

</template>

<style scoped>

/*==================================================================*/
/*================== Header ========================================*/
/*==================================================================*/

.c-header {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: max-content;
}

.c-header__titulo {
    font-size: 1.25rem;
    font-weight: 700;
}

/*==================================================================*/
/*================== Grid ==========================================*/
/*==================================================================*/

.c-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

@media (max-width: 768px) {
    .c-grid {
        display: grid;
        grid-template-columns: 1fr;
        grid-auto-rows: max-content;
    }
}

</style>
